import { render, staticRenderFns } from "./defined-dropdownlist-selector.vue?vue&type=template&id=10779277&"
import script from "./defined-dropdownlist-selector.vue?vue&type=script&lang=ts&"
export * from "./defined-dropdownlist-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports